import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { BrowserRouter } from 'react-router-dom';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { reportQueryError } from './shared/utils/docNotFound';
import './i18n';
import App from './App';
import { migrateLegacySession } from './auth/bootstrap';
import { ConfirmProvider } from './components/ConfirmProvider';
import { ToastProviderWithBridge } from './components/ToastProvider';
import './styles.css';
import { installFieldNames } from './shared/utils/fieldNames';
// ч.962: тема/масштаб з дзеркала localStorage — ДО першого рендера,
// щоб при завантаженні не «спалахувала» світла тема у нічному режимі.
import './store/appearance';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

// 2026-07-25 (клас «після деплою видно стару версію до подвійного F5»):
// registerSW з virtual-модуля замість голого navigator.serviceWorker.register —
// у режимі autoUpdate він сам перезавантажує сторінку, щойно НОВИЙ service
// worker перейняв керування (controllerchange). Без цього SW віддавав старий
// precache-бандл: перший F5 показував стару версію (нова лише встановлювалась
// у фоні), другий — нову; між вкладками «мигали» різні версії застосунку.
registerSW({ immediate: true });

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
  // ч.1312: 404 на документ, відкритий за посиланням, — плашка в макеті (docNotFound.ts).
  queryCache: new QueryCache({ onError: reportQueryError }),
});

// ч.1397: стара сесія з localStorage → httpOnly-cookie одним запитом, і лише тоді рендер.
void migrateLegacySession().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ToastProviderWithBridge>
            <ConfirmProvider>
              <App />
            </ConfirmProvider>
          </ToastProviderWithBridge>
        </QueryClientProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
  installFieldNames();
});
